import { render } from "./XIcons.vue?vue&type=template&id=59f6d44a"
import script from "./XIcons.vue?vue&type=script&lang=js"
export * from "./XIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__